import axios from "@/plugins/axios";

const NOT_APPROVED_MESSAGE =
  "Su usuario se encuentra no aprobado o suspendido. Para mayor información, comuníquese con un administrador de Ridery";

function commitMe(commit, data) {
  const { corporate } = data;
  const isCorporateMaster =
    corporate.is_corporate_master ?? corporate.isCorporateMaster;
  const billingDataId = corporate.billing_data_id ?? corporate.billingDataId;
  const canCreateTrips = data.enable_corporate_invoice_overdue_blocking
    ? !corporate.has_overdue_invoices
    : true;

  const isInternal = corporate.is_internal ?? corporate.isInternal ?? false;
  const isBillingIncomplete =
    !isCorporateMaster && !billingDataId && !isInternal;
  commit("SET_BILLING_INCOMPLETE", isBillingIncomplete);
  commit("SET_USER", {
    user: corporate.email ?? data.email,
    _id: corporate._id ?? data._id,
    unique_id: corporate.unique_id ?? data.unique_id,
    is_assist_mode: corporate.is_assist_mode ?? data.is_assist_mode,
  });
  commit("SET_ME", {
    email: corporate.email,
    name: corporate.name,
    countryName: corporate.country_name ?? corporate.countryName,
    phone: corporate.phone,
    countryPhoneCode:
      corporate.country_phone_code ?? corporate.countryPhoneCode,
    wallet: corporate.wallet,
    overdraft: corporate.overdraft,
    canCreateTrips,
    // en caso improbable de usd y bs vengan ambos distintos a cero, usd tiene prioridad
    walletExcess:
      corporate.wallet_excess_usd || corporate.wallet_excess_bs || 0,
    walletExcessCurrency:
      (corporate.wallet_excess_usd > 0 && "USD") ||
      (corporate.wallet_excess_bs > 0 && "VES") ||
      "USD",
    picture_url: corporate.image_url ?? corporate.picture_url ?? null,
    pre_time: data.pre_time ?? corporate.preTime,
    admin_phone: data.admin_phone ?? corporate.adminPhone,
    admin_email: data.admin_email ?? corporate.adminEmail,
    is_active_shipments:
      corporate.is_active_shipments ?? corporate.isActiveShipments,
    is_active_multi_stops:
      corporate.is_active_multi_stops ?? corporate.isActiveMultiStops,
    is_corporate_master:
      corporate.is_corporate_master ?? corporate.isCorporateMaster,
    is_used_google_maps_service:
      data.is_used_google_maps_service ?? corporate.isUsedGoogleMapsService,
    updated_at: corporate.updated_at ?? corporate.updatedAt,
    is_allow_credits: corporate.is_allow_credits ?? corporate.isAllowCredits,
    credits_due: corporate.credits_due ?? corporate.creditsDue,
    associated_panels: data.associated_panels ?? corporate.associatedPanels,
    is_corporate_api_partner:
      corporate.is_corporate_api_partner ?? corporate.isCorporateApiPartner,
    is_allowed_corporate_shipment_api:
      corporate.is_allowed_corporate_shipment_api ??
      corporate.isAllowedCorporateShipmentApi,
    is_allowed_corporate_api_partner:
      data.isAllowedCorporateApiPartner ??
      data.is_allowed_corporate_api_partner,
    sales_executive_phone: corporate?.sales_executive?.phone || null,
    sales_executive_country_phone_code:
      corporate?.sales_executive?.country_phone_code || null,
    must_change_password: data.must_change_password === true,
    is_assist_mode: data.is_assist_mode,
    times_visited_invoice_ad:
      corporate.times_visited_invoice_ad ?? corporate.timesVisitedInvoiceAd,
    hide_invoice_ad: corporate.hide_invoice_ad ?? corporate.hideInvoiceAd,
    is_internal: isInternal,
  });
}

export async function signIn({ commit }, user) {
  commit("SET_LOADING", true, { root: true });
  try {
    const { data } = await axios.post("/login", {
      email: user.email,
      password: user.password,
      captchaToken: user.captchaToken,
    });
    if (data) {
      commit("SET_USER", {
        user: data.email,
        _id: data._id,
        unique_id: data.unique_id,
        must_change_password: data.must_change_password === true,
      });
      commit("SET_TOKEN", data.token);
    }
  } catch (e) {
    throw e;
  } finally {
    commit("SET_LOADING", false, { root: true });
  }
}

export function setCurrentUser({ commit }) {
  commit("SET_USER", user);
}

export async function me({ commit }) {
  try {
    commit("SET_LOADING", true, { root: true });
    const { data } = await axios.get("/me");
    const corporate = data?.corporate;
    const isApproved =
      corporate && (corporate.is_approved === 1 || corporate.isApproved === 1);
    if (data && isApproved) {
      commitMe(commit, data);
    } else {
      commit("LOGOUT", null);
      throw new Error("not approved");
    }
  } catch (e) {
    if (e?.message === "not approved") {
      throw new Error(NOT_APPROVED_MESSAGE);
    } else {
      throw e;
    }
  } finally {
    commit("SET_LOADING", false, { root: true });
  }
}

export async function meNotLoading({ commit }) {
  try {
    const { data } = await axios.get("/me");
    const corporate = data?.corporate;
    const isApproved =
      corporate && (corporate.is_approved === 1 || corporate.isApproved === 1);
    if (data && isApproved) {
      commitMe(commit, data);
    } else {
      commit("LOGOUT", null);
      throw new Error("not approved");
    }
  } catch (e) {
    if (e?.message === "not approved") {
      throw new Error(NOT_APPROVED_MESSAGE);
    } else {
      throw e;
    }
  }
}

export async function refreshPermissions({ commit, state }) {
  if (!state.token) return;
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_STAGING}/v2/corporate/permissions`,
    );
    if (!data || !data.data || data.success === false) {
      throw new Error("Invalid permissions response");
    }
    commit("SET_PERMISSIONS", {
      is_active_shipments: data.data.is_active_shipments,
      is_active_multi_stops: data.data.is_active_multi_stops,
      is_corporate_master: data.data.is_corporate_master,
      is_allow_credits: data.data.is_allow_credits,
      is_corporate_api_partner: data.data.is_corporate_api_partner,
      is_allowed_corporate_shipment_api:
        data.data.is_allowed_corporate_shipment_api,
    });
  } catch (e) {
    throw e;
  }
}

export async function logout({ commit }) {
  try {
    commit("SET_LOADING", true, { root: true });
    // await axios.post('/api/v1/logout')
    commit("LOGOUT", null);
  } catch (e) {
    throw new Error("Error desconocido");
  } finally {
    commit("SET_LOADING", false, { root: true });
  }
}

export async function setLang({ commit }, lang) {
  commit("SET_LANG", lang);
}

/**
 * Force-change an expired corporate password.
 * On success the backend invalidates the session (token: ''); we complete
 * the logout on the FE side so the store is cleared and the user is sent
 * back to the login page.
 */
export async function changeExpiredPassword(
  { dispatch },
  { old_password, new_password, confirm_password },
) {
  await axios.post(
    `${process.env.VUE_APP_STAGING}/v2/corporate/change_password`,
    {
      old_password,
      new_password,
      confirm_password,
    },
  );
  await dispatch("logout");
  return true;
}

export function setBillingIncomplete({ commit }, value) {
  commit("SET_BILLING_INCOMPLETE", value);
}
